import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    tarjetaResumenId: 0,
    banco: '',
    tarjetaMarca: '',
    numeroCuenta: '',
    fechaCierre: '1900-01-01',
    fechaVencimiento: '1900-01-01',
    saldoAnteriorPesos: 0,
    totalPlasticosPesos: 0,
    importeConsumosPesos: 0,
    importeGastosPesos: 0,
    saldoAnteriorDolares: 0,
    totalPlasticosDolares: 0,
    importeConsumosDolares: 0,
    importeGastosDolares: 0,
    observaciones: '',
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, tarjetaResumenId) {
        state.tarjetaResumenId = tarjetaResumenId;
        state.banco = '';
        state.tarjetaMarca = '';
        state.numeroCuenta = '';
        state.fechaCierre = '1900-01-01';
        state.fechaVencimiento = '1900-01-01';
        state.saldoAnteriorPesos = 0;
        state.totalPlasticosPesos = 0;
        state.importeConsumosPesos = 0;
        state.importeGastosPesos = 0;
        state.saldoAnteriorDolares = 0;
        state.totalPlasticosDolares = 0;
        state.importeConsumosDolares = 0;
        state.importeGastosDolares = 0;
        state.observaciones = '';
    },
    'SET_TARJETA_RESUMEN' (state, tarjetaResumen) {
        state.banco = tarjetaResumen.banco;
        state.tarjetaMarca = tarjetaResumen.tarjetaMarca;
        state.numeroCuenta = tarjetaResumen.numeroCuenta;
        state.fechaCierre = moment(tarjetaResumen.fechaCierre).format('YYYY-MM-DD');
        state.fechaVencimiento = moment(tarjetaResumen.fechaVencimiento).format('YYYY-MM-DD');
        state.saldoAnteriorPesos = tarjetaResumen.saldoAnteriorPesos;
        state.saldoAnteriorDolares = tarjetaResumen.saldoAnteriorDolares;
        state.totalPlasticosPesos = 0;
        state.totalPlasticosDolares = 0;
        tarjetaResumen.plasticos.forEach(plastico => {
            let totalPlasticoPesos = plastico.cuotas
                .reduce((total, cuota) => total + cuota.importeCuotaPesos, 0);

            let totalPlasticoDolares = plastico.cuotas
                .reduce((total, cuota) => total + cuota.importeCuotaDolares, 0);

            plastico.totalesCuotas = [
                {
                    titulo: 'Total',
                    totalPesos: totalPlasticoPesos,
                    totalDolares: totalPlasticoDolares
                }
            ]
            
            state.totalPlasticosPesos += totalPlasticoPesos;
            state.totalPlasticosDolares += totalPlasticoDolares;
        });
    },    
};

const actions = {
    inicializar ( { commit }, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', tarjetaResumenId);

            apiAxios.get(`tarjetasresumenes/${tarjetaResumenId}/vencimiento`)
                .then(res => {
                    commit('SET_TARJETA_RESUMEN', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let tarjetaResumenCierre = {
                importeConsumosPesos: state.importeConsumosPesos,
                importeGastosPesos: state.importeGastosPesos,
                importeConsumosDolares: state.importeConsumosDolares,
                importeGastosDolares: state.importeGastosDolares,
                observaciones: state.observaciones
            };

            apiAxios.post(`tarjetasresumenes/${state.tarjetaResumenId}/cierre`, tarjetaResumenCierre)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    delete ( {}, tarjetaResumenId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post(`tarjetasresumenes/${tarjetaResumenId}/cierre/delete`)
                .then( () => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    }
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}